import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonIcon, fontColors } from '@sphereon/ui-components.core';
import SSIAddIcon from '../../assets/icons/SSIAddIcon';
import SSIFilterIcon from '../../assets/icons/SSIFilterIcon';
import SSIArrowDownIcon from '../../assets/icons/SSIArrowDownIcon';
import { SSIIconButtonContainerStyled as Container, SSITextH3Styled as Caption } from '../../../styles';
import MeatBallsIcon from '../../assets/icons/MeatBallsIcon';
import DeleteIcon from '../../assets/icons/DeleteIcon';
const SSIIconButton = (props) => {
    const { caption, icon, onClick, disabled = false, iconColor = fontColors.dark } = props;
    return _jsxs(Container, { onClick: onClick, children: [getIcon(icon, iconColor), caption && _jsx(Caption, { children: caption })] });
};
const getIcon = (icon, color) => {
    switch (icon) {
        case ButtonIcon.ADD:
            return _jsx(SSIAddIcon, { color: color });
        case ButtonIcon.ARROW_DOWN:
            return _jsx(SSIArrowDownIcon, { color: color });
        case ButtonIcon.MEATBALLS:
            return _jsx(MeatBallsIcon, { color: color });
        case ButtonIcon.DELETE:
            return _jsx(DeleteIcon, { color: color, width: 15, height: 16 });
        case ButtonIcon.FILTER:
            return _jsx(SSIFilterIcon, { color: color });
        default:
            return _jsx("div", {});
    }
};
export default SSIIconButton;
